import { Request } from "@/utils";
import { GestureType } from "@/types";

class Salary extends Request {
    getGesture() {
        return this.get<GestureType>({
            url: '/mobile/salary/getGesture',
        });
    }
    checkQwVerifyCode(code: string) {
        return this.get<string>({
            url: '/mobile/salary/checkQwVerifyCode?code='+code,
        });
    }
    saveGesture(gesture: string) {
        return this.post<string>({
            url: '/mobile/salary/saveGesture',
            data: {gesture}
        });
    }
    sendQwVerifyCode() {
        return this.get<string>({
            url: '/mobile/salary/sendQwVerifyCode',
        });
    }
}

export const SalaryApi = new Salary();